// import React, { useEffect, useState } from "react";
// import { pvr, shopping_cart } from "../../Image/Index";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { countryRegions } from "../../actions/auth";
// import getSymbolFromCurrency from "currency-symbol-map";
// import { decrypt, encrypt } from "../../utils/encodingdecoding";
// import Header from "../layout/Header";
// import Swal from "sweetalert2";

// const ResellerDetails = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const pageType = location?.state?.for;
//     let cardDetails = localStorage.getItem("card") && JSON.parse(decrypt(localStorage.getItem("card")));
//     const isMultiple = localStorage.getItem("isMultipleSelection") && decrypt(localStorage.getItem("isMultipleSelection"));

//     const [state, setState] = useState({
//         detail: {},
//         currencySymbol: getSymbolFromCurrency("INR"),
//         cardData: [],
//     });
//     const [err, setErr] = useState(false);
//     const [loader, setLoader] = useState(false);
//     const { detail, currencySymbol, cardData } = state;
//     useEffect(() => {
//         let cardTemp = [];
//         if (pageType === "edit") {
//             let cardTemp = cardDetails?.filter((detail) => {
//                 if (detail.code === location.state.code) {
//                     return {
//                         ...detail,
//                         fix_value: parseInt(detail.fix_value),
//                         savings: parseFloat(detail.savings),
//                         discount: parseFloat(detail.discount),
//                         total: parseFloat(detail.total),
//                         quantity: parseInt(detail.quantity),
//                         discountedValue: parseFloat(detail.discountedValue),
//                         currencySymbol: detail.currencySymbol,
//                     };
//                 }
//             });
//             setState((prev) => ({
//                 ...prev,
//                 cardData: cardTemp,
//                 currencySymbol: cardTemp?.[0].currencySymbol,
//             }));
//         } else {
//             let tempFix_value;
//             location?.state?.vendors?.map((ele) => {
//                 if (location?.state?.default_vendor_code === ele.vendor_code) {
//                     ele.denominations.map((denom, i) => {
//                         if (location?.state?.price_type === "range") {
//                             if (i === 0) {
//                                 tempFix_value = denom.fix_value;
//                             } else {
//                                 cardTemp.push({ fix_value: null, range: [tempFix_value, denom.fix_value], price_type: location.state.price_type, quantity: 0, total: 0, savings: 0, discount: location?.state?.discount ? parseFloat(location?.state?.discount) : 0, discountedValue: 0, code: location.state.code, name: location?.state?.title, image: location?.state?.image, currencySymbol: "", category: location?.state?.category, vendor_id: location?.state?.default_vendor_code, category: "", merchantName: location.state.merchantName, id: location?.state?.vendors[0]?.vendor_giftcard_id });
//                             }
//                         } else {
//                             cardTemp.push({ fix_value: denom.fix_value, price_type: location.state.price_type, quantity: 0, total: 0, savings: 0, discount: location?.state?.discount ? parseFloat(location?.state?.discount) : 0, discountedValue: 0, code: location.state.code, name: location?.state?.title, image: location?.state?.image, currencySymbol: "", category: location?.state?.category, vendor_id: location?.state?.default_vendor_code, category: "", merchantName: location.state.merchantName, id: location?.state?.vendors[0]?.vendor_giftcard_id });
//                         }
//                     });
//                 }
//             });
//             let storeCart = cardDetails?.filter((detail) => {
//                 if (detail.code === location.state.code) {
//                     return detail;
//                 }
//             });
//             storeCart?.map((cart) => {
//                 cardTemp?.map((temp, index) => {
//                     if (temp.price_type === "range") {
//                         cardTemp[index] = {
//                             ...temp,
//                             fix_value: parseInt(cart.fix_value),
//                             savings: parseInt(cart.savings),
//                             discount: parseFloat(cart.discount),
//                             total: parseFloat(cart.total),
//                             quantity: parseInt(cart.quantity),
//                             discountedValue: parseInt(cart.discountedValue),
//                         };
//                     } else {
//                         if (temp.fix_value === cart.fix_value) {
//                             cardTemp[index] = {
//                                 ...temp,
//                                 savings: parseInt(cart.savings),
//                                 discount: parseFloat(cart.discount),
//                                 total: parseFloat(cart.total),
//                                 quantity: parseInt(cart.quantity),
//                                 discountedValue: parseInt(cart.discountedValue),
//                             };
//                         }
//                     }
//                 });
//             });
//             setState((prev) => ({
//                 ...prev,
//                 detail: location.state,
//                 cardData: cardTemp,
//             }));

//             if (isMultiple === "false") {
//                 if (location.state.merchantName === "qc") {
//                     let count = [];
//                     cardDetails?.length &&
//                         cardDetails?.filter((ele, ind) => {
//                             if (ele.quantity > 0 && ele.code === location.state.code) {
//                                 count.push(ind);
//                             }
//                         });
//                     if (count?.length) {
//                         setState((prev) => ({
//                             ...prev,
//                             cardData: cardTemp?.map((data) => {
//                                 if (data?.quantity > 0) {
//                                     return {
//                                         ...data,
//                                         enable: true,
//                                     };
//                                 } else {
//                                     return {
//                                         ...data,
//                                         enable: false,
//                                         quantity: 0,
//                                     };
//                                 }
//                             }),
//                         }));
//                     }
//                 }

//                 if (location.state.merchantName === "razor-pay") {
//                     let count = [];
//                     cardDetails?.length &&
//                         cardDetails?.filter((ele, ind) => {
//                             if (ele.quantity > 0 && ele.code === location.state.code) {
//                                 count.push(ind);
//                             }
//                         });
//                     if (count?.length === 4) {
//                         setState((prev) => ({
//                             ...prev,
//                             cardData: cardTemp?.map((data, ind) => {
//                                 if (data.quantity > 0) {
//                                     return {
//                                         ...data,
//                                         enable: true,
//                                     };
//                                 } else {
//                                     return {
//                                         ...data,
//                                         enable: false,
//                                         quantity: 0,
//                                     };
//                                 }
//                             }),
//                         }));
//                     }
//                 }
//             }
//         }
//     }, [location]);

//     useEffect(() => {
//         cardData?.length &&
//             cardData?.map((ele) => {
//                 if (ele.rangeErr || ele.quanErr) {
//                     setErr(true);
//                 } else {
//                     setErr(false);
//                 }
//             });
//     }, [cardData]);

//     const handleQuantity = (type, i, merchant, quantity) => {
//         if (type === "Inc") {
//             setState((prev) => ({
//                 ...prev,
//                 cardData: prev?.cardData?.map((data, ind) => {
//                     if (i === ind) {
//                         let tempTotal = parseInt(data.fix_value) * (parseInt(data.quantity) + 1);
//                         return {
//                             ...data,
//                             quantity: data.quantity ? parseInt(data.quantity) + 1 : 1,
//                             total: parseFloat(data.fix_value) * (parseFloat(data.quantity) + 1),
//                             savings: tempTotal ? tempTotal - (tempTotal - (tempTotal * data.discount) / 100) : 0,
//                             discountedValue: tempTotal ? tempTotal - (tempTotal * data.discount) / 100 : 0,
//                             currencySymbol: currencySymbol,
//                             quanErr: isMultiple === "false" && (merchant === "qc" ? data.quantity >= 19 && true : data.quantity >= 3 && true),
//                         };
//                     } else {
//                         return data;
//                     }
//                 }),
//             }));

//             if (isMultiple === "false") {
//                 if (merchant === "qc") {
//                     setState((prev) => ({
//                         ...prev,
//                         cardData: prev?.cardData?.map((data, ind) => {
//                             if (i === ind) {
//                                 return {
//                                     ...data,
//                                     enable: true,
//                                 };
//                             } else {
//                                 return {
//                                     ...data,
//                                     enable: false,
//                                     quantity: 0,
//                                 };
//                             }
//                         }),
//                     }));
//                 }

//                 if (merchant === "razor-pay") {
//                     let count = [];
//                     cardData.filter((ele, ind) => {
//                         if (ele.quantity > 0) {
//                             count.push(ind);
//                         }
//                     });
//                     const countTemp = count.filter((ele) => ele !== i);

//                     if (countTemp.length === 3) {
//                         setState((prev) => ({
//                             ...prev,
//                             cardData: prev?.cardData?.map((data, ind) => {
//                                 if (i === ind) {
//                                     return {
//                                         ...data,
//                                         enable: true,
//                                     };
//                                 } else if (data.quantity > 0) {
//                                     return {
//                                         ...data,
//                                         enable: true,
//                                     };
//                                 } else {
//                                     return {
//                                         ...data,
//                                         enable: false,
//                                     };
//                                 }
//                             }),
//                         }));
//                     }
//                 }
//             }
//         } else {
//             setState((prev) => ({
//                 ...prev,
//                 cardData: prev?.cardData?.map((data, ind) => {
//                     if (i === ind) {
//                         let tempTotal = parseInt(data.fix_value) * (parseInt(data.quantity) - 1);
//                         return {
//                             ...data,
//                             quantity: parseInt(data.quantity) - 1,
//                             total: parseFloat(data.fix_value) * (parseFloat(data.quantity) - 1),
//                             savings: tempTotal ? tempTotal - (tempTotal - (tempTotal * data.discount) / 100) : 0,
//                             discountedValue: tempTotal ? tempTotal - (tempTotal * data.discount) / 100 : 0,
//                             currencySymbol: currencySymbol,
//                             quanErr: isMultiple === "false" && (merchant === "qc" ? data.quantity > 21 && true : data.quantity > 5 && true),
//                         };
//                     } else {
//                         return data;
//                     }
//                 }),
//             }));

//             if (merchant === "qc") {
//                 setState((prev) => ({
//                     ...prev,
//                     cardData: prev?.cardData?.map((data, ind) => {
//                         if (i === ind) {
//                             return {
//                                 ...data,
//                                 enable: data.quantity > 0 ? true : "",
//                             };
//                         } else {
//                             return {
//                                 ...data,
//                                 enable: quantity > 1 ? false : true,
//                             };
//                         }
//                     }),
//                 }));
//             }

//             if (merchant === "razor-pay") {
//                 let count = [];
//                 cardData.filter((ele, ind) => {
//                     if (ele.quantity > 0) {
//                         count.push(ind);
//                     }
//                 });
//                 const countTemp = count.filter((ele) => ele !== i);
//                 if (countTemp.length === 3) {
//                     setState((prev) => ({
//                         ...prev,
//                         cardData: prev?.cardData?.map((data, ind) => {
//                             if (i === ind) {
//                                 return {
//                                     ...data,
//                                     enable: data.quantity > 0 ? true : "",
//                                 };
//                             } else if (data.quantity > 0) {
//                                 return {
//                                     ...data,
//                                     enable: true,
//                                 };
//                             } else {
//                                 return {
//                                     ...data,
//                                     enable: quantity > 1 ? false : true,
//                                     quantity: 0,
//                                 };
//                             }
//                         }),
//                     }));
//                 }
//             }
//         }
//     };

//     const handleChange = (e, i, merchant) => {
//         setState((prev) => ({
//             ...prev,
//             cardData: prev?.cardData?.map((data, ind) => {
//                 if (i === ind) {
//                     let tempTotal = parseInt(data.fix_value) * (parseInt(e.target.value) ? parseInt(e.target.value) : 0);
//                     return {
//                         ...data,
//                         quantity: e.target.value,
//                         total: parseFloat(data.fix_value) * (parseFloat(e.target.value) ? parseFloat(e.target.value) : 0),
//                         savings: tempTotal ? tempTotal - (tempTotal - (tempTotal * data.discount) / 100) : 0,
//                         discountedValue: tempTotal ? tempTotal - (tempTotal * data.discount) / 100 : 0,
//                         currencySymbol: currencySymbol,
//                         quanErr: isMultiple === "false" && (merchant === "qc" ? e.target.value > 20 && true : e.target.value > 4 && true),
//                     };
//                 } else {
//                     return data;
//                 }
//             }),
//         }));

//         if (isMultiple === "false") {
//             if (merchant === "qc") {
//                 setState((prev) => ({
//                     ...prev,
//                     cardData: prev?.cardData?.map((data, ind) => {
//                         if (i === ind) {
//                             return {
//                                 ...data,
//                                 enable: true,
//                             };
//                         } else {
//                             return {
//                                 ...data,
//                                 enable: e.target.value === "" ? true : false,
//                             };
//                         }
//                     }),
//                 }));
//             }

//             if (merchant === "razor-pay") {
//                 let count = [];
//                 cardData.filter((ele, ind) => {
//                     if (ele.quantity > 0 && ele.quantity !== "") {
//                         count.push(ind);
//                     }
//                 });
//                 if (count.length === 3 || count.length === 4) {
//                     setState((prev) => ({
//                         ...prev,
//                         cardData: prev?.cardData?.map((data, ind) => {
//                             if (i === ind) {
//                                 return {
//                                     ...data,
//                                     enable: true,
//                                 };
//                             } else if (data.quantity > 0) {
//                                 return {
//                                     ...data,
//                                     enable: true,
//                                 };
//                             } else {
//                                 return {
//                                     ...data,
//                                     enable: e.target.value === "" ? true : false,
//                                     quantity: 0,
//                                 };
//                             }
//                         }),
//                     }));
//                 }
//             }
//         }
//     };
//     const getTotalSum = () => {
//         let sum = 0;
//         cardData?.forEach((item) => {
//             sum += item.discountedValue;
//         });
//         return sum.toFixed(2);
//     };

//     const getTotalSavings = () => {
//         let sum = 0;
//         cardData?.forEach((item) => {
//             sum += item.savings;
//         });
//         return sum.toFixed(2);
//     };

//     const cartItem = () => {
//         let newCard = [];
//         cardData?.map((ele) => {
//             if (ele.total > 0) {
//                 newCard.push(ele);
//                 return newCard;
//             }
//         });
//         if (newCard?.length) {
//             return newCard.length;
//         } else {
//             return 0;
//         }
//     };

//     const handleRange = (e, i) => {
//         setState((prev) => ({
//             ...prev,
//             cardData: prev?.cardData?.map((data, ind) => {
//                 if (i === ind) {
//                     let tempTotal = parseInt(data.quantity) * (parseInt(e.target.value) ? parseInt(e.target.value) : 0);
//                     return {
//                         ...data,
//                         total: parseFloat(data.quantity) * (parseFloat(e.target.value) ? parseFloat(e.target.value) : 0),
//                         savings: tempTotal ? tempTotal - (tempTotal - (tempTotal * data.discount) / 100) : 0,
//                         discountedValue: tempTotal ? tempTotal - (tempTotal * data.discount) / 100 : 0,
//                         currencySymbol: currencySymbol,
//                         rangeErr: e.target.value ? (e.target.value >= data.range[0] && e.target.value <= data.range[1] ? false : true) : false,
//                         fix_value: e.target.value,
//                     };
//                 } else {
//                     return data;
//                 }
//             }),
//         }));
//     };

//     const handleCart = () => {
//         if (isMultiple === "true") {
//             let newCard = [];
//             cardData?.map((ele) => {
//                 if (ele.total > 0) {
//                     newCard.push(ele);
//                     return newCard;
//                 }
//             });
//             if (Array.isArray(cardDetails) && cardDetails?.length) {
//                 let storeCart = cardDetails?.filter((detail) => {
//                     if (detail.code !== location.state.code) {
//                         return detail;
//                     }
//                 });
//                 let temp = [...storeCart, ...newCard];
//                 localStorage.setItem("card", encrypt(JSON.stringify(temp)));
//             } else {
//                 localStorage.setItem("card", encrypt(JSON.stringify(newCard)));
//             }
//             navigate("/reseller-cart");
//         } else {
//             if (Array.isArray(cardDetails) && cardDetails.length > 0) {
//                 if (pageType === "edit") {
//                     let newCard = [];
//                     cardData?.map((ele) => {
//                         if (ele.total > 0) {
//                             newCard.push(ele);
//                             return newCard;
//                         }
//                     });

//                     localStorage.setItem("card", encrypt(JSON.stringify(newCard)));
//                     navigate("/reseller-cart");
//                 } else {
//                     Swal.fire({
//                         title: "Are you sure?",
//                         text: "No two different brand's vouchers can be added at the same time. Multiple vouchers of same brand can be added at a time.",
//                         icon: "warning",
//                         showCancelButton: true,
//                         confirmButtonColor: "#3085d6",
//                         cancelButtonColor: "#d33",
//                         confirmButtonText: "Yes, Replace it!",
//                     }).then((result) => {
//                         if (result.isConfirmed) {
//                             let newCard = [];
//                             cardData?.map((ele) => {
//                                 if (ele.total > 0) {
//                                     newCard.push(ele);
//                                     return newCard;
//                                 }
//                             });
//                             console.log(newCard, "edghi");
//                             localStorage.setItem("card", encrypt(JSON.stringify(newCard)));
//                             navigate("/reseller-cart");
//                         }
//                     });
//                 }
//             } else {
//                 let newCard = [];
//                 cardData?.map((ele) => {
//                     if (ele.total > 0) {
//                         newCard.push(ele);
//                         return newCard;
//                     }
//                 });
//                 localStorage.setItem("card", encrypt(JSON.stringify(newCard)));
//                 navigate("/reseller-cart");
//             }
//         }
//     };
//     return (
//         <>
//             {loader && (
//                 <div className="mainPreloaderMain">
//                     <div className="mainPreloader">
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                     </div>
//                 </div>
//             )}
//             <div className="reseller_home">
//                 <Header name="Gift Card Details" cartQuan={cartItem()} pageType={pageType} />
//                 <div className="reseller_home__body">
//                     <div className="card_header">
//                         <div className="card_header_box">
//                             <div className="card_header_left">
//                                 <div className="card_header_i">
//                                     <img src={pageType === "edit" ? cardData[0]?.image : detail.image} />
//                                 </div>
//                                 <div className="card_header_c">
//                                     <h4>{pageType === "edit" ? cardData[0]?.name : detail.title}</h4>
//                                     <p className="discount_label">{detail.discount && `${detail.discount}% Off`}</p>
//                                     {/* <p>Category: {pageType === "edit" ? cardData[0]?.category : detail.category}</p> */}
//                                 </div>
//                             </div>
//                             <div className="card_header_right">
//                                 <div className="cart_box">
//                                     <div className="cart_box_left">
//                                         <h5>
//                                             Total {currencySymbol} {getTotalSum()}
//                                         </h5>
//                                         <p className="savings">
//                                             Savings {currencySymbol} {getTotalSavings()}
//                                         </p>
//                                     </div>
//                                     <div className="cart_box_right">
//                                         <button type="button" onClick={handleCart} disabled={cartItem() <= 0 || err}>
//                                             <span>{cartItem()}</span>
//                                             <img src={shopping_cart} />
//                                             <p>{cartItem() > 0 ? "Add to Cart" : "Empty Cart"}</p>
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="card_body">
//                         <div className="card_body_header">
//                             <div className="card_body_header_title">MRP</div>
//                             <div className="card_body_header_title">Discount</div>
//                             <div className="card_body_header_title">Your Savings</div>
//                             <div className="card_body_header_title">Quantity</div>
//                             <div className="card_body_header_title">Total</div>
//                         </div>
//                         <div className="card_body_box">
//                             {cardData?.length > 0 &&
//                                 cardData?.map((ele, i) => {
//                                     return (
//                                         <div className={typeof ele.enable == "boolean" ? (ele.enable ? "card_body_result" : "card_body_result disabled") : "card_body_result"} key={i}>
//                                             {ele.price_type === "range" ? (
//                                                 ele?.range?.length &&
//                                                 ele.range.map(
//                                                     (type, ind) =>
//                                                         ind !== 0 && (
//                                                             <div className="card_body_box_results">
//                                                                 <p className={ele.rangeErr ? "range_text error" : "range_text"}>
//                                                                     Range from {ele.range[0]} to {ele.range[1]}
//                                                                 </p>
//                                                                 <input
//                                                                     value={ele.fix_value}
//                                                                     onChange={(e) => {
//                                                                         const inputValue = e.target.value.replace(/[^0-9]/g, "");
//                                                                         handleRange({ target: { value: inputValue } }, i);
//                                                                     }}
//                                                                     className="card_input"
//                                                                     placeholder="Enter your value"
//                                                                 />
//                                                             </div>
//                                                         )
//                                                 )
//                                             ) : (
//                                                 <div className="card_body_box_results">
//                                                     {currencySymbol} {ele.fix_value}
//                                                 </div>
//                                             )}
//                                             <div className="card_body_box_results discounted">{ele.discount ? `${ele.discount}%` : "-"}</div>
//                                             <div className="card_body_box_results discounted">
//                                                 {currencySymbol} {ele.savings.toFixed(2)}
//                                             </div>
//                                             <div className="card_body_box_results card_quantity">
//                                                 <div className="qty-container">
//                                                     <button className="qty-btn-minus" onClick={() => handleQuantity("Dec", i, ele.merchantName, ele.quantity)} disabled={ele.quantity <= 0}>
//                                                         -
//                                                     </button>
//                                                     <input
//                                                         type="text"
//                                                         className="input-qty"
//                                                         pattern="[0-9]*"
//                                                         onChange={(e) => {
//                                                             const inputValue = e.target.value.replace(/[^0-9]/g, "");
//                                                             handleChange({ target: { value: inputValue } }, i, ele.merchantName);
//                                                         }}
//                                                         value={ele.quantity}
//                                                     />
//                                                     {isMultiple === "true" ? (
//                                                         <button className="qty-btn-plus" onClick={() => handleQuantity("Inc", i)}>
//                                                             +
//                                                         </button>
//                                                     ) : (
//                                                         <button className="qty-btn-plus" onClick={() => handleQuantity("Inc", i, ele.merchantName)} disabled={ele.merchantName === "razor-pay" ? ele.quantity >= 4 : ele.quantity >= 20}>
//                                                             +
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                                 {ele.quanErr && (ele.merchantName === "qc" ? <div className="error">Quantity should be less than or equal to 20</div> : <div className="error">Quantity should be less than or equal to 4</div>)}
//                                             </div>
//                                             <div className="card_body_box_results resulted">
//                                                 {currencySymbol} {ele.total ? ele.total - (ele.total * ele.discount) / 100 : 0}
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default ResellerDetails;

import React, { useEffect, useState } from 'react';
import { shopping_cart } from '../../Image/Index';
import { useLocation, useNavigate } from 'react-router-dom';
import getSymbolFromCurrency from 'currency-symbol-map';
import { decrypt, encrypt } from '../../utils/encodingdecoding';
import Header from '../layout/Header';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import {
	addToCart,
	clearCart,
	getCartDetails,
	updateExitingCartItem,
} from '../../actions/auth';
import { Multiplier } from '../../utils/helper';

const ResellerDetails = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const pageType = location?.state?.for;
	const detail = location?.state || {};

	const merchant =
		detail.merchantName?.toLowerCase() === 'qwikcilver'
			? 'qc'
			: detail.merchantName?.toLowerCase();

	const maxQty = Number(detail.max_quantity || 20);
	const discount = Number(detail.client_details?.discount || 0);

	const cardDetails =
		localStorage.getItem('card') &&
		JSON.parse(decrypt(localStorage.getItem('card')));

	const isMultiple =
		localStorage.getItem('isMultipleSelection') &&
		decrypt(localStorage.getItem('isMultipleSelection'));

	const [state, setState] = useState({
		detail: {},
		currencySymbol: getSymbolFromCurrency('INR'),
		cardData: [],
	});

	const [err, setErr] = useState(false);
	const [loader] = useState(false);

	const { cardData, currencySymbol } = state;

	/* ---------------- INIT ---------------- */
	useEffect(() => {
		let cardTemp = [];

		/* -------- EDIT MODE (UNCHANGED LOGIC) -------- */
		if (pageType === 'edit') {
			const edited = cardDetails?.filter((d) => d.code === detail.code);

			setState((prev) => ({
				...prev,
				cardData: edited || [],
				currencySymbol: edited?.[0]?.currencySymbol || currencySymbol,
			}));
			return;
		}

		/* -------- FIXED + RANGE DENOMINATIONS -------- */
		let tempFixValue;

		detail.denominations?.forEach((denom, i) => {
			const price_type =
				denom.value_type?.toLowerCase() === 'range' ? 'range' : 'fixed';

			if (price_type === 'range') {
				if (i === 0) {
					tempFixValue = Number(denom.fix_value);
				} else {
					cardTemp.push({
						fix_value: null,
						range: [tempFixValue, Number(denom.fix_value)],
						price_type: 'range',
						quantity: 0,
						total: 0,
						savings: 0,
						discount,
						discountedValue: 0,
						code: detail.code,
						name: detail.title,
						image: detail.image,
						currencySymbol,
						category: detail.category,
						vendor_id: detail.default_vendor_code,
						merchantName: merchant,
						id: detail.id,
					});
				}
			} else {
				cardTemp.push({
					fix_value: Number(denom.fix_value),
					price_type: 'fixed',
					quantity: 0,
					total: 0,
					savings: 0,
					discount,
					discountedValue: 0,
					code: detail.code,
					name: detail.title,
					image: detail.image,
					currencySymbol,
					category: detail.category,
					vendor_id: detail.default_vendor_code,
					merchantName: merchant,
					id: detail.id,
				});
			}
		});

		/* -------- MERGE EXISTING CART (UNCHANGED LOGIC) -------- */
		const storedSameBrand = cardDetails?.filter(
			(d) => d.code === detail.code,
		);

		storedSameBrand?.forEach((cart) => {
			cardTemp = cardTemp.map((temp) => {
				if (temp.price_type === 'range') {
					return {
						...temp,
						fix_value: Number(cart.fix_value),
						savings: Number(cart.savings),
						discount: Number(cart.discount),
						total: Number(cart.total),
						quantity: Number(cart.quantity),
						discountedValue: Number(cart.discountedValue),
					};
				}

				if (temp.fix_value === cart.fix_value) {
					return {
						...temp,
						savings: Number(cart.savings),
						discount: Number(cart.discount),
						total: Number(cart.total),
						quantity: Number(cart.quantity),
						discountedValue: Number(cart.discountedValue),
					};
				}

				return temp;
			});
		});

		setState((prev) => ({
			...prev,
			detail,
			cardData: cardTemp,
		}));
	}, [location]);

	/* ---------------- ERROR WATCH ---------------- */
	useEffect(() => {
		setErr(cardData.some((e) => e.rangeErr || e.quanErr));
	}, [cardData]);

	/* ---------------- RANGE HANDLER ---------------- */
	const handleRange = (e, i) => {
		setState((prev) => ({
			...prev,
			cardData: prev.cardData.map((d, idx) => {
				if (idx !== i) return d;

				const value = Number(e.target.value || 0);
				const total = d.quantity * value;

				return {
					...d,
					fix_value: value,
					total,
					discountedValue: total - (total * d.discount) / 100,
					savings: (total * d.discount) / 100,
					rangeErr: value
						? value < d.range[0] || value > d.range[1]
						: false,
				};
			}),
		}));
	};

	/* ---------------- QUANTITY HANDLER ---------------- */

	const hasOtherSelectedDenomination = (cardData, currentIndex) =>
		cardData.some((d, idx) => idx !== currentIndex && d.quantity > 0);

	const resetOtherDenominations = (cardData, currentIndex) =>
		cardData.map((d, idx) =>
			idx === currentIndex
				? d
				: {
						...d,
						quantity: 0,
						total: 0,
						savings: 0,
						discountedValue: 0,
						rangeErr: false,
						quanErr: false,
				  },
		);
	const handleQuantity = (type, i) => {
		setState((prev) => {
			const currentQty = prev.cardData[i].quantity;
			const nextQty =
				type === 'Inc' ? currentQty + 1 : Math.max(0, currentQty - 1);

			const isActualIncrease = nextQty > currentQty;

			if (
				isActualIncrease &&
				hasOtherSelectedDenomination(prev.cardData, i)
			) {
				Swal.fire({
					title: 'Are you sure?',
					text: 'Changing this denomination will overwrite the previously selected denomination.',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Yes, continue',
				}).then((res) => {
					if (res.isConfirmed) {
						setState((prevState) => ({
							...prevState,
							cardData: resetOtherDenominations(
								prevState.cardData,
								i,
							).map((d, idx) => {
								if (idx !== i) return d;

								const total = (d.fix_value || 0) * nextQty;

								return {
									...d,
									quantity: nextQty,
									total,
									discountedValue:
										total - (total * d.discount) / 100,
									savings: (total * d.discount) / 100,
									quanErr: nextQty > maxQty,
								};
							}),
						}));
					}
				});

				return prev;
			}

			// Normal flow
			return {
				...prev,
				cardData: prev.cardData.map((d, idx) => {
					if (idx !== i) return d;

					const total = (d.fix_value || 0) * nextQty;

					return {
						...d,
						quantity: nextQty,
						total,
						discountedValue: total - (total * d.discount) / 100,
						savings: (total * d.discount) / 100,
						quanErr: nextQty > maxQty,
					};
				}),
			};
		});
	};

	/* ---------------- INPUT CHANGE ---------------- */

	const handleChange = (e, i) => {
		const rawValue = e.target.value;

		// Allow empty input safely
		if (rawValue === '') {
			setState((prev) => ({
				...prev,
				cardData: prev.cardData.map((d, idx) =>
					idx === i
						? {
								...d,
								quantity: 0,
								total: 0,
								savings: 0,
								discountedValue: 0,
								quanErr: false,
						  }
						: d,
				),
			}));
			return;
		}

		const value = Number(rawValue);

		setState((prev) => {
			const currentQty = prev.cardData[i].quantity;

			// 🔑 Trigger only on actual increase
			const isActualIncrease = value > currentQty;

			const hasOther =
				isActualIncrease &&
				hasOtherSelectedDenomination(prev.cardData, i);

			if (hasOther) {
				Swal.fire({
					title: 'Are you sure?',
					text: 'Changing this denomination will overwrite the previously selected denomination.',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Yes, continue',
				}).then((res) => {
					if (res.isConfirmed) {
						setState((prevState) => ({
							...prevState,
							cardData: resetOtherDenominations(
								prevState.cardData,
								i,
							).map((d, idx) => {
								if (idx !== i) return d;

								const total = (d.fix_value || 0) * value;

								return {
									...d,
									quantity: value,
									total,
									discountedValue:
										total - (total * d.discount) / 100,
									savings: (total * d.discount) / 100,
									quanErr: value > maxQty,
								};
							}),
						}));
					}
				});

				return prev;
			}

			// ✅ Normal update
			return {
				...prev,
				cardData: prev.cardData.map((d, idx) => {
					if (idx !== i) return d;

					const total = (d.fix_value || 0) * value;

					return {
						...d,
						quantity: value,
						total,
						discountedValue: total - (total * d.discount) / 100,
						savings: (total * d.discount) / 100,
						quanErr: value > maxQty,
					};
				}),
			};
		});
	};

	/* ---------------- TOTALS ---------------- */
	const getTotalSum = () =>
		cardData.reduce((s, i) => s + i.discountedValue, 0).toFixed(2);

	const getTotalSavings = () =>
		cardData.reduce((s, i) => s + i.savings, 0).toFixed(2);

	const cartItem = () => cardData.filter((i) => i.total > 0).length;

	/* ---------------- CART ---------------- */
	// const handleCart = () => {
	// 	const newCard = cardData.filter((i) => i.total > 0);

	// 	if (!newCard.length) return;

	// 	// ✅ EDIT CASE: item already exists in cart
	// 	const isEditCase = cardDetails?.some((c) => c.code === detail.code);

	// 	if (isEditCase) {
	// 		const filtered =
	// 			cardDetails?.filter((c) => c.code !== detail.code) || [];

	// 		localStorage.setItem(
	// 			'card',
	// 			encrypt(JSON.stringify([...filtered, ...newCard])),
	// 		);
	// 		navigate('/reseller-cart');
	// 		return;
	// 	}

	// 	// 🔹 MULTIPLE SELECTION (unchanged)
	// 	if (isMultiple === 'true') {
	// 		const filtered =
	// 			cardDetails?.filter((c) => c.code !== detail.code) || [];

	// 		localStorage.setItem(
	// 			'card',
	// 			encrypt(JSON.stringify([...filtered, ...newCard])),
	// 		);
	// 		navigate('/reseller-cart');
	// 		return;
	// 	}

	// 	// 🔹 SINGLE BRAND CONFIRMATION (unchanged)
	// 	if (cardDetails?.length && pageType !== 'edit') {
	// 		Swal.fire({
	// 			title: 'Are you sure?',
	// 			text: "No two different brand's vouchers can be added at the same time.",
	// 			icon: 'warning',
	// 			showCancelButton: true,
	// 			confirmButtonText: 'Yes, Replace it!',
	// 		}).then((res) => {
	// 			if (res.isConfirmed) {
	// 				localStorage.setItem(
	// 					'card',
	// 					encrypt(JSON.stringify(newCard)),
	// 				);
	// 				navigate('/reseller-cart');
	// 			}
	// 		});
	// 		return;
	// 	}

	// 	// 🔹 NEW ADD
	// 	localStorage.setItem('card', encrypt(JSON.stringify(newCard)));
	// 	navigate('/reseller-cart');
	// };

	// const handleCart = async () => {
	// 	const selectedItems = cardData.filter((i) => i.total > 0);
	// 	if (!selectedItems.length) return;

	// 	const profile = JSON.parse(localStorage.getItem('profile'));
	// 	const cart_code = sessionStorage.getItem('cartCode')
	// 		? decrypt(sessionStorage.getItem('cartCode'))
	// 		: '';

	// 	for (const item of selectedItems) {
	// 		// 🔹 UPDATE EXISTING CART
	// 		if (cart_code) {
	// 			await dispatch(
	// 				updateExitingCartItem({
	// 					user_code: decrypt(profile?.merchantcode),
	// 					cart_code: cart_code,
	// 					product_code: detail.code,
	// 					quantity: item.quantity,
	// 					client_id: decrypt(localStorage.getItem('clientid')),
	// 					item_type: 'Giftcard',
	// 					...item,
	// 				}),
	// 			);
	// 		}
	// 		// 🔹 ADD TO CART
	// 		else {
	// 			await dispatch(
	// 				addToCart({
	// 					product_code: detail.code,
	// 					item_type: 'Giftcard',
	// 					quantity: item.quantity,
	// 					user_code: decrypt(profile?.merchantcode),
	// 					denomination: Number(item.fix_value),
	// 					vendor_code: item.default_vendor_code,
	// 					// sender_name: data.senderName,
	// 					// receiver_name: data.recipientName,
	// 					// receiver_email: data.recipientEmail,
	// 					// receiver_mobile:
	// 					// 	subdomain === EDSRING
	// 					// 		? mobile
	// 					// 		: cleanMobileNumber(data.recipientMobile),
	// 					// ...(data.message && {
	// 					// 	message: data.message,
	// 					// }),
	// 					// tnc: data.agreement,
	// 					...item,
	// 				}),
	// 			);
	// 		}
	// 	}

	// 	// 🔄 ALWAYS REFRESH CART
	// 	if (profile?.merchantcode) {
	// 		dispatch(
	// 			getCartDetails({
	// 				customerCode: profile.merchantcode,
	// 			}),
	// 		);
	// 	}

	// 	navigate('/reseller-cart');
	// };

	// const handleCart = async () => {
	// 	const newCard = cardData.filter((i) => i.total > 0);
	// 	if (!newCard.length) return;

	// 	const profile = localStorage.getItem('profile')
	// 		? JSON.parse(localStorage.getItem('profile'))
	// 		: {};
	// 	const venDetails = sessionStorage.getItem('venDetails')
	// 		? JSON.parse(decrypt(sessionStorage.getItem('venDetails')))
	// 		: {};
	// 	const cart_code = sessionStorage.getItem('cartCode')
	// 		? decrypt(sessionStorage.getItem('cartCode'))
	// 		: '';

	// 	const merchantCode = decrypt(profile?.merchantcode);
	// 	const clientId = decrypt(localStorage.getItem('clientid'));

	// 	// ✅ EDIT CASE (UNCHANGED)
	// 	const isEditCase = cardDetails?.some((c) => c.code === detail.code);

	// 	if (isEditCase) {
	// 		const filtered =
	// 			cardDetails?.filter((c) => c.code !== detail.code) || [];

	// 		localStorage.setItem(
	// 			'card',
	// 			encrypt(JSON.stringify([...filtered, ...newCard])),
	// 		);

	// 		// 🔁 API UPDATE (denomination / qty change)
	// 		if (cart_code) {
	// 			for (const item of newCard) {
	// 				await dispatch(
	// 					updateExitingCartItem({
	// 						user_code: merchantCode,
	// 						cart_code,
	// 						quantity: item.quantity,
	// 						client_id: clientId,
	// 						item_type: 'Giftcard',
	// 						product_code: detail.code,
	// 						vendor_code: item.default_vendor_code,
	// 						quantity: item.quantity,
	// 						denomination: Number(item.fix_value),
	// 						discount_price: Number(item.discountedValue),
	// 						discount_percentage: Number(item.discount),
	// 						amount: Number(item.total),
	// 						max_quantity: String(detail.max_quantity || 5),
	// 						sender_name: venDetails.name,
	// 						receiver_name: venDetails.name,
	// 						receiver_email: venDetails.contactEmail,
	// 						receiver_mobile: venDetails.contactMobile,
	// 						...item,
	// 					}),
	// 				);
	// 			}
	// 		}

	// 		navigate('/reseller-cart');
	// 		return;
	// 	}

	// 	// 🔹 MULTIPLE SELECTION (UNCHANGED)
	// 	if (isMultiple === 'true') {
	// 		const filtered =
	// 			cardDetails?.filter((c) => c.code !== detail.code) || [];

	// 		localStorage.setItem(
	// 			'card',
	// 			encrypt(JSON.stringify([...filtered, ...newCard])),
	// 		);

	// 		// ➕ API ADD
	// 		for (const item of newCard) {
	// 			await dispatch(
	// 				addToCart({
	// 					name: item.name,
	// 					product_code: detail.code,
	// 					vendor_code: item.default_vendor_code,
	// 					quantity: item.quantity,
	// 					item_type: 'Giftcard',
	// 					user_code: merchantCode,
	// 					denomination: Number(item.fix_value),
	// 					discount_price: Number(item.discountedValue),
	// 					discount_percentage: Number(item.discount),
	// 					amount: Number(item.total),
	// 					// delivery_charge: 100, // set as per API requirement
	// 					image: item.image || '',
	// 					max_quantity: Number(detail.max_quantity),
	// 					sender_name: venDetails?.name || null,
	// 					receiver_name: venDetails?.name || null,
	// 					receiver_email: venDetails?.contactEmail || null,
	// 					receiver_mobile: venDetails?.contactMobile || null,
	// 					...item,
	// 				}),
	// 			);
	// 		}

	// 		navigate('/reseller-cart');
	// 		return;
	// 	}

	// 	// 🔹 SINGLE BRAND CONFIRMATION (UNCHANGED)
	// 	if (cardDetails?.length && pageType !== 'edit') {
	// 		Swal.fire({
	// 			title: 'Are you sure?',
	// 			text: "No two different brand's vouchers can be added at the same time.",
	// 			icon: 'warning',
	// 			showCancelButton: true,
	// 			confirmButtonText: 'Yes, Replace it!',
	// 		}).then(async (res) => {
	// 			if (!res.isConfirmed) return;

	// 			// 🔥 CLEAR REDUX CART ONLY (NOT localStorage)
	// 			dispatch(clearCart());

	// 			localStorage.setItem('card', encrypt(JSON.stringify(newCard)));

	// 			//  API ADD
	// 			for (const item of newCard) {
	// 				await dispatch(
	// 					addToCart({
	// 						name: item.name,
	// 						product_code: detail.code,
	// 						vendor_code: item.default_vendor_code,
	// 						quantity: item.quantity,
	// 						item_type: 'Giftcard',
	// 						user_code: merchantCode,
	// 						denomination: Number(item.fix_value),
	// 						discount_price: Number(item.discountedValue),
	// 						discount_percentage: Number(item.discount),
	// 						amount: Number(item.total),
	// 						// delivery_charge: 100, // set as per API requirement
	// 						image: item.image || '',
	// 						max_quantity: Number(detail.max_quantity),
	// 						sender_name: venDetails?.name || null,
	// 						receiver_name: venDetails?.name || null,
	// 						receiver_email: venDetails?.contactEmail || null,
	// 						receiver_mobile: venDetails?.contactMobile || null,
	// 						...item,
	// 					}),
	// 				);
	// 			}

	// 			navigate('/reseller-cart');
	// 		});
	// 		return;
	// 	}

	// 	// 🔹 NEW ADD (UNCHANGED)
	// 	localStorage.setItem('card', encrypt(JSON.stringify(newCard)));

	// 	for (const item of newCard) {
	// 		await dispatch(
	// 			addToCart({
	// 				name: item.name,
	// 				product_code: detail.code,
	// 				vendor_code: item.default_vendor_code,
	// 				quantity: item.quantity,
	// 				item_type: 'Giftcard',
	// 				user_code: merchantCode,
	// 				denomination: Number(item.fix_value),
	// 				discount_price: Number(item.discountedValue),
	// 				discount_percentage: Number(item.discount),
	// 				amount: Number(item.total),
	// 				// delivery_charge: 100, // set as per API requirement
	// 				image: item.image || '',
	// 				max_quantity: Number(detail.max_quantity),
	// 				sender_name: venDetails?.name || null,
	// 				receiver_name: venDetails?.name || null,
	// 				receiver_email: venDetails?.contactEmail || null,
	// 				receiver_mobile: venDetails?.contactMobile || null,
	// 				...item,
	// 			}),
	// 		);
	// 	}

	// 	navigate('/reseller-cart');
	// };

	const safeJSONParse = (value, fallback = {}) => {
		try {
			return value ? JSON.parse(value) : fallback;
		} catch {
			return fallback;
		}
	};

	const safeDecryptParse = (value, fallback = {}) => {
		try {
			return value ? JSON.parse(decrypt(value)) : fallback;
		} catch {
			return fallback;
		}
	};

	const handleCart = async () => {
		const newCard = cardData.filter((i) => i.total > 0);
		if (!newCard.length) return;

		const profile = safeJSONParse(localStorage.getItem('profile'), {});
		const venDetails = safeDecryptParse(
			sessionStorage.getItem('venDetails'),
			{},
		);

		const cart_code = (() => {
			try {
				const code = sessionStorage.getItem('cartCode');
				return code ? decrypt(code) : '';
			} catch {
				return '';
			}
		})();

		const merchantCode = (() => {
			try {
				return decrypt(profile?.merchantcode);
			} catch {
				return '';
			}
		})();

		const clientId = (() => {
			try {
				return decrypt(localStorage.getItem('clientid'));
			} catch {
				return '';
			}
		})();

		//  EDIT CASE (UNCHANGED)
		const isEditCase = cardDetails?.some((c) => c.code === detail.code);

		if (isEditCase) {
			const filtered =
				cardDetails?.filter((c) => c.code !== detail.code) || [];

			localStorage.setItem(
				'card',
				encrypt(JSON.stringify([...filtered, ...newCard])),
			);

			if (cart_code) {
				for (const item of newCard) {
					await dispatch(
						updateExitingCartItem({
							user_code: merchantCode,
							cart_code,
							client_id: clientId,
							item_type: 'Giftcard',
							product_code: detail.code,
							vendor_code: item.default_vendor_code,
							quantity: item.quantity,
							denomination: Number(item.fix_value),
							discount_price: Number(item.discountedValue),
							discount_percentage: Number(item.discount),
							amount: Number(item.total),
							max_quantity: String(detail.max_quantity || 5),
							sender_name: venDetails.name,
							receiver_name: venDetails.name,
							receiver_email: venDetails.contactEmail,
							receiver_mobile: venDetails.contactMobile,
							...item,
						}),
					);
				}
			}

			navigate('/reseller-cart');
			return;
		}

		// 🔹 MULTIPLE SELECTION (UNCHANGED)
		if (isMultiple === 'true') {
			const filtered =
				cardDetails?.filter((c) => c.code !== detail.code) || [];

			localStorage.setItem(
				'card',
				encrypt(JSON.stringify([...filtered, ...newCard])),
			);

			for (const item of newCard) {
				await dispatch(
					addToCart({
						name: item.name,
						product_code: detail.code,
						vendor_code: item.default_vendor_code,
						quantity: item.quantity,
						item_type: 'Giftcard',
						user_code: merchantCode,
						denomination: Number(item.fix_value),
						discount_price: Number(item.discountedValue),
						discount_percentage: Number(item.discount),
						amount: Number(item.total),
						image: item.image || '',
						max_quantity: Number(detail.max_quantity),
						sender_name: venDetails?.name || null,
						receiver_name: venDetails?.name || null,
						receiver_email: venDetails?.contactEmail || null,
						receiver_mobile: venDetails?.contactMobile || null,
						...item,
					}),
				);
			}

			navigate('/reseller-cart');
			return;
		}

		// 🔹 SINGLE BRAND CONFIRMATION (UNCHANGED)
		if (cardDetails?.length && pageType !== 'edit') {
			Swal.fire({
				title: 'Are you sure?',
				text: "No two different brand's vouchers can be added at the same time.",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Yes, Replace it!',
			}).then(async (res) => {
				if (!res.isConfirmed) return;

				dispatch(clearCart());

				localStorage.setItem('card', encrypt(JSON.stringify(newCard)));

				for (const item of newCard) {
					await dispatch(
						addToCart({
							name: item.name,
							product_code: detail.code,
							vendor_code: item.default_vendor_code,
							quantity: item.quantity,
							item_type: 'Giftcard',
							user_code: merchantCode,
							denomination: Number(item.fix_value),
							discount_price: Number(item.discountedValue),
							discount_percentage: Number(item.discount),
							amount: Number(item.total),
							image: item.image || '',
							max_quantity: Number(detail.max_quantity),
							sender_name: venDetails?.name || null,
							receiver_name: venDetails?.name || null,
							receiver_email: venDetails?.contactEmail || null,
							receiver_mobile: venDetails?.contactMobile || null,
							...item,
						}),
					);
				}

				navigate('/reseller-cart');
			});
			return;
		}

		// 🔹 NEW ADD (UNCHANGED)
		localStorage.setItem('card', encrypt(JSON.stringify(newCard)));

		for (const item of newCard) {
			await dispatch(
				addToCart({
					name: item.name,
					product_code: detail.code,
					vendor_code: item.default_vendor_code,
					quantity: item.quantity,
					item_type: 'Giftcard',
					user_code: merchantCode,
					denomination: Number(item.fix_value),
					discount_price: Number(item.discountedValue),
					discount_percentage: Number(item.discount),
					amount: Number(item.total),
					image: item.image || '',
					max_quantity: Number(detail.max_quantity),
					sender_name: venDetails?.name || null,
					receiver_name: venDetails?.name || null,
					receiver_email: venDetails?.contactEmail || null,
					receiver_mobile: venDetails?.contactMobile || null,
					...item,
				}),
			);
		}

		navigate('/reseller-cart');
	};

	/* ---------------- UI ---------------- */
	return (
		<>
			{loader && (
				<div className='mainPreloaderMain'>
					<div className='mainPreloader'>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}

			<div className='reseller_home'>
				<Header
					name='Gift Card Details'
					cartQuan={cartItem()}
					pageType={pageType}
				/>

				<div className='reseller_home__body'>
					<div className='card_header'>
						<div className='card_header_box'>
							<div className='card_header_left'>
								<div className='card_header_i'>
									<img
										src={
											pageType === 'edit'
												? cardData[0]?.image
												: detail.image
										}
									/>
								</div>
								<div className='card_header_c'>
									<h4>
										{pageType === 'edit'
											? cardData[0]?.name
											: detail.title}
									</h4>
									<p className='discount_label'>
										{discount ? `${discount}% Off` : ''}
									</p>
								</div>
							</div>

							<div className='card_header_right'>
								<div className='cart_box'>
									<div className='cart_box_left'>
										<h5>
											Total {currencySymbol}{' '}
											{getTotalSum()}
										</h5>
										<h5>
											{Number(getTotalSum() ?? 0) *
												Multiplier}{' '}
											Points
										</h5>
										<p className='savings'>
											Savings {currencySymbol}{' '}
											{getTotalSavings()}
										</p>
									</div>
									<div className='cart_box_right'>
										<button
											type='button'
											onClick={handleCart}
											disabled={cartItem() <= 0 || err}>
											<span>{cartItem()}</span>
											<img src={shopping_cart} />
											<p>
												{cartItem() > 0
													? 'Add to Cart'
													: 'Empty Cart'}
											</p>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className='card_body'>
						<div className='card_body_header'>
							<div className='card_body_header_title'>MRP</div>
							<div className='card_body_header_title'>
								Discount
							</div>
							<div className='card_body_header_title'>
								Your Savings
							</div>
							<div className='card_body_header_title'>
								Quantity
							</div>
							<div className='card_body_header_title'>Total</div>
						</div>

						<div className='card_body_box'>
							{cardData.map((ele, i) => (
								<div
									className='card_body_result'
									key={i}>
									{ele.price_type === 'range' ? (
										<div className='card_body_box_results'>
											<p
												className={
													ele.rangeErr
														? 'range_text error'
														: 'range_text'
												}>
												Range from {ele.range[0]} to{' '}
												{ele.range[1]}
											</p>
											<input
												value={ele.fix_value}
												onChange={(e) =>
													handleRange(
														{
															target: {
																value: e.target.value.replace(
																	/[^0-9]/g,
																	'',
																),
															},
														},
														i,
													)
												}
												className='card_input'
												placeholder='Enter your value'
											/>
										</div>
									) : (
										<div className='card_body_box_results'>
											{currencySymbol} {ele.fix_value}
										</div>
									)}

									<div className='card_body_box_results discounted'>
										{ele.discount
											? `${ele.discount}%`
											: '-'}
									</div>

									<div className='card_body_box_results discounted'>
										{currencySymbol}{' '}
										{ele.savings.toFixed(2)}
									</div>

									<div className='card_body_box_results card_quantity'>
										<div className='qty-container'>
											<button
												className='qty-btn-minus'
												onClick={() =>
													handleQuantity(
														'Dec',
														i,
														ele.merchantName,
													)
												}
												disabled={ele.quantity <= 0}>
												-
											</button>

											<input
												className='input-qty'
												value={ele.quantity}
												onChange={(e) =>
													handleChange(
														{
															target: {
																value: e.target.value.replace(
																	/[^0-9]/g,
																	'',
																),
															},
														},
														i,
														ele.merchantName,
													)
												}
											/>

											<button
												className='qty-btn-plus'
												onClick={() =>
													handleQuantity(
														'Inc',
														i,
														ele.merchantName,
													)
												}>
												+
											</button>
										</div>

										{ele.quanErr && (
											<div className='error'>
												Quantity should be less than or
												equal to {maxQty}
											</div>
										)}
									</div>

									<div className='card_body_box_results resulted'>
										{currencySymbol}{' '}
										{ele.total
											? ele.total -
											  (ele.total * ele.discount) / 100
											: 0}
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ResellerDetails;
